export default [
  {
    path: "/ClientPage/BSEditPassword",
    name: "BSEditPassword",
    component: () => import("@/views/pages/ClientPage/ClientEditPassword.vue"),
    props: true,

    meta: {
      pageTitle: "修改密碼",
      breadcrumb: [
        {
          text: "會員登錄",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/ClientEditPassword",
    name: "ClientEditPassword",
    component: () => import("@/views/pages/ClientPage/ClientEditPassword.vue"),
    props: true,

    meta: {
      pageTitle: "修改密碼",
      breadcrumb: [
        {
          text: "會員登錄",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/BSBillSearch",
    name: "BSBillSearch",
    component: () => import("@/views/pages/ClientPage/BSPage/BSBillSearch.vue"),
    props: true,

    meta: {
      pageTitle: "發票查詢",
      breadcrumb: [
        {
          text: "客戶專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/BSTradeInfo",
    name: "BSTradeInfo",
    component: () => import("@/views/pages/ClientPage/BSPage/BSTradeInfo.vue"),
    props: true,

    meta: {
      pageTitle: "專戶交易資訊",
      breadcrumb: [
        {
          text: "客戶專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/LAagentsearchcase",
    name: "LAagentsearchcase",
    component: () =>
      import(
        "@/views/pages/ClientPage/LAagentPage/LAagentsearchcase/LAagentsearchcase.vue"
      ),
    props: true,

    meta: {
      pageTitle: "案件查詢",
      breadcrumb: [
        {
          text: "地政士專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/LAagentfundsearch",
    name: "LAagentfundsearch",
    component: () =>
      import(
        "@/views/pages/ClientPage/LAagentPage/LAagentFundSearch/ClientFundSearch.vue"
      ),
    props: true,

    meta: {
      pageTitle: "資金明細查詢",
      breadcrumb: [
        {
          text: "地政士專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/LAagentNews",
    name: "LAagentNews",
    component: () => import("@/views/pages/ClientPage/ClientNews.vue"),
    props: true,

    meta: {
      pageTitle: "最新消息",
      breadcrumb: [
        {
          text: "地政士專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/ClientNews_Body",
    name: "ClientNews_Body",
    component: () => import("@/views/pages/ClientPage/ClientNews_Body.vue"),
    props: true,

    meta: {
      pageTitle: "最新消息",
      breadcrumb: [
        {
          text: "地政士專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/IntermediaryNews",
    name: "IntermediaryNews",
    component: () => import("@/views/pages/ClientPage/ClientNews.vue"),
    props: true,

    meta: {
      pageTitle: "最新消息",
      breadcrumb: [
        {
          text: "仲介專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/LAagentQA",
    name: "LAagentQA",
    component: () => import("@/views/pages/ClientPage/ClientQA.vue"),
    props: true,

    meta: {
      pageTitle: "問與答",
      breadcrumb: [
        {
          text: "地政士專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/IntermediaryQA",
    name: "IntermediaryQA",
    component: () => import("@/views/pages/ClientPage/ClientQA.vue"),
    props: true,

    meta: {
      pageTitle: "問與答",
      breadcrumb: [
        {
          text: "仲介專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/LAagentform",
    name: "LAagentform",
    component: () => import("@/views/pages/ClientPage/ClientForm.vue"),
    props: true,

    meta: {
      pageTitle: "相關作業表單列印",
      breadcrumb: [
        {
          text: "地政士專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/Intermediaryform",
    name: "Intermediaryform",
    component: () => import("@/views/pages/ClientPage/ClientForm.vue"),
    props: true,

    meta: {
      pageTitle: "相關作業表單列印",
      breadcrumb: [
        {
          text: "仲介專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/Intermediaryfund",
    name: "Intermediaryfund",
    component: () =>
      import(
        "@/views/pages/ClientPage/IntermediaryPage/IntermediaryFundSearch/ClientFundSearch.vue"
      ),
    props: true,

    meta: {
      pageTitle: "已出款服務費查詢",
      breadcrumb: [
        {
          text: "仲介專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/Intermediarycase",
    name: "Intermediarycase",
    component: () =>
      import(
        "@/views/pages/ClientPage/IntermediaryPage/Intermediarycase/Intermediarycase.vue"
      ),
    props: true,

    meta: {
      pageTitle: "案件查詢",
      breadcrumb: [
        {
          text: "仲介專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/IntermediaryAssistantAccount",
    name: "IntermediaryAssistantAccount",
    component: () =>
      import(
        "@/views/pages/ClientPage/IntermediaryPage/IntermediaryAssistantAccount/IntermediaryAssistantAccount.vue"
      ),
    props: true,

    meta: {
      pageTitle: "店長/秘書維護",
      breadcrumb: [
        {
          text: "仲介專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/LAagentAssistantAccount",
    name: "LAagentAssistantAccount",
    component: () =>
      import(
        "@/views/pages/ClientPage/LAagentPage/LAagentAssistantAccount/LAagentAssistantAccount.vue"
      ),
    props: true,

    meta: {
      pageTitle: "助理帳號維護",
      breadcrumb: [
        {
          text: "地政士專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/ClientMessagePage",
    name: "ClientMessagePage",
    component: () => import("@/views/pages/ClientPage/ClientMessagePage.vue"),
    props: true,
    breadcrumb: [
      {
        text: "訊息管理",
        active: false,
      },
    ],
    meta: {
      pageTitle: "訊息查詢",
    },
  },
  {
    path: "/ClientPage/LAagentfundsearch",
    name: "businessFundsearch",
    component: () =>
      import(
        "@/views/pages/ClientPage/LAagentPage/LAagentFundSearch/ClientFundSearch.vue"
      ),
    props: true,

    meta: {
      pageTitle: "資金明細查詢",
      breadcrumb: [
        {
          text: "業務專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/LAagentsearchcase",
    name: "businessSearchcase",
    component: () =>
      import(
        "@/views/pages/ClientPage/LAagentPage/LAagentsearchcase/LAagentsearchcase.vue"
      ),
    props: true,

    meta: {
      pageTitle: "案件查詢",
      breadcrumb: [
        {
          text: "業務專區",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ClientPage/LAagentform",
    name: "businessForm",
    component: () => import("@/views/pages/ClientPage/ClientForm.vue"),
    props: true,

    meta: {
      pageTitle: "相關作業表單列印",
      breadcrumb: [
        {
          text: "業務專區",
          active: true,
        },
      ],
    },
  },
];
